<template>
  <div class="row justify-content-between" v-if="term">
    <div class="col-md-12 col-sm-12 form-group position-relative">
      <label for>{{ $t(`edit_template_term`)}} {{$t(`create_template_title_${language?.toUpperCase()}`) }}</label>
      <input
        type="text"
        v-model="term.title"
        :class="[
          'form-control pr-1',
          this.language === 'ar' && 'text-right',
          this.isSubmitted && !term.title?.trim() ? 'validation-error' : '',
        ]"
        :placeholder="$t('edit_template_enter_term_title')"
      />
      <button
        class="btn btn-default position-absolute p-0"
        type="button"
        style="top: -10px; right: 10px"
        @click="onDelete"
        v-if="!disableDelete"
      >
        <em class="bx bx-trash" style="font-size: 1.5em"></em>
      </button>
    </div>
    <div class="col-md-12 col-sm-12 form-group">
      <label for="password">{{
        $t(`edit_template_term`)
      }} {{$t(`create_template_description_${language?.toUpperCase()}`) }}</label>
      <textarea
        cols="30"
        rows="5"
        v-model="term.description"
        :class="[
          'form-control',
          this.language === 'ar' && 'text-right',
          this.isSubmitted && !term.description?.trim() ? 'validation-error' : '',
        ]"
        :placeholder="$t('edit_template_enter_term_description')"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: ["language", "term", "onTermsDelete", "deleteIndex", "isSubmitted","disableDelete"],
  methods: {
    onDelete: function () {
      if (this.onTermsDelete) {
        this.onTermsDelete(this.deleteIndex);
      }
    },
  },
};
</script>

<style scoped>
.validation-error {
  border: solid 1px red !important;
}
</style>
